// extracted by mini-css-extract-plugin
module.exports = {"LeagueTable":"style_LeagueTable__2zz9w","runnerDetails":"style_runnerDetails__3wT3R"};